import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col, Button } from "reactstrap"

//Import Countdown
import Countdown from "react-countdown"

//Import Images
import logodark from "../../assets/images/caretip.jpg"
import logolight from "../../assets/images/caretip.jpg"
import maintanence from "../../assets/images/coming-soon.svg"
import { useNavigate } from "react-router-dom";

const Confirm = () => {

      const navigate = useNavigate();

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>You are good to go!</span>
    } else {
      return (
        <>
          <div className="coming-box">
            {days} <span>Days</span>
          </div>{" "}
          <div className="coming-box">
            {hours} <span>Hours</span>
          </div>{" "}
          <div className="coming-box">
            {minutes} <span>Minutes</span>
          </div>{" "}
          <div className="coming-box">
            {seconds} <span>Seconds</span>
          </div>
        </>
      )
    }
  }

  const goHome = () => {
    navigate("/") // Navigates to the home page
  }

  //meta title
  document.title = "Confirmation | Care-Tip Admin & Dashboard"

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-white">
          <i className="fas fa-home h2" />
        </Link>
      </div>

      <div className="my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="100"
                    className="logo-dark-element rounded-circle"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="100"
                    className="logo-light-element rounded-circle"
                    // style={{ display: 'block', margin: '0 auto' }}
                  />
                </Link>
                <h4 className="mt-5"> Care-Tip Confirmation</h4>

                <Row className="justify-content-center mt-5">
                  <Col sm="4">
                    <div className="maintenance-img">
                      <img
                        src={maintanence}
                        alt=""
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                  </Col>
                </Row>
                <p className="text-muted">
                  Thank you for submitting your application!
                </p>
                <p className="text-muted">
                  Your application has been received and is currently under
                  review. We appreciate your interest and effort.
                </p>
                <Row className="justify-content-center mt-5">
                  <Col md="8">
                    <div
                      className="counter-number"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button color="primary" onClick={() => goHome()}>
                        Continue
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Confirm
